import type { ButtonsFragmentFragment } from "@commerce-frontend/types";
import { graphql } from "@commerce-frontend/types";
import { cn } from "@commerce-frontend/ui/helpers/styles";
import { type HTMLAttributes, forwardRef } from "react";
import { Button } from "../Button/Button";

export const ButtonsFragment = graphql(/* GraphQL */ `
	fragment ButtonsFragment on Buttons {
		__typename
		id
		buttons {
			...ButtonFragment
		}
	}
`);

type Props = {
	data: ButtonsFragmentFragment;
} & HTMLAttributes<HTMLDivElement>;

export const Buttons = forwardRef<HTMLDivElement, Props>(
	({ data, className, ...attributes }, ref) => (
		<div
			{...attributes}
			className={cn("flex flex-row flex-wrap gap-x-3 gap-y-2xl", className)}
			ref={ref}
		>
			{(data.buttons || []).map((button) => (
				<div key={button.id}>
					<Button data={button} />
				</div>
			))}
		</div>
	),
);

Buttons.displayName = "Buttons";
